var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-wrapper",class:{ loading: _vm.loading },attrs:{"id":"mindMapping"},on:{"click":function($event){return _vm.handleExport(true)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }